<script lang="ts">
  import { type ComponentProps } from "svelte";
  import { dataField } from "../../../lib/dataform/dataFormLib.svelte";
  import Fieldset from "../Fieldset.svelte";
  import { setFieldContext, type FieldContext } from "./context";

  type PropsType = ComponentProps<typeof Fieldset> & {
    name: string;
    required?: boolean;
  }

  let {
    name,
    required = false,
    ...rest
  } : PropsType = $props();

  const field = dataField(name)
  let fieldContext: FieldContext = $derived({field, required})
  setFieldContext(fieldContext)
</script>
<Fieldset error={field.error as string} legendClass="pb-4" {...rest} />
